import Icon from '../components/Icon.vue'

Icon.register({
  cat: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M290.6 192C270.4 192 183.8 194 128 277.9V192C128 139.1 84.9 96 32 96 14.3 96 0 110.3 0 128S14.3 160 32 160C49.6 160 64 174.4 64 192V448C64 483.3 92.7 512 128 512H304C312.8 512 320 504.8 320 496V480C320 462.3 305.7 448 288 448H256L384 352V496C384 504.8 391.2 512 400 512H432C440.8 512 448 504.8 448 496V289.9C437.7 292.5 427.1 294.4 416 294.4 354.2 294.4 302.5 250.3 290.6 192zM448 96H384L320 32V166.4C320 219.4 363 262.4 416 262.4S512 219.4 512 166.4V32L448 96zM376 176C367.2 176 360 168.8 360 160S367.2 144 376 144 392 151.2 392 160 384.8 176 376 176zM456 176C447.2 176 440 168.8 440 160S447.2 144 456 144 472 151.2 472 160 464.8 176 456 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cat.js
// module id = ytpF
// module chunks = 144